import { useState } from "react";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "../ui/dialog";
import { api } from "../../lib/api";

export const PRICE = "€9.99";

// Email + secure payment on Stripe; the PDF link comes back on the success page and by email.
export const BuyIssue = ({ open, onOpenChange, title }) => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const pay = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/shop/checkout", { email, origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (err) {
      toast.error(err?.response?.data?.detail?.[0]?.msg ? "Check your email address" : "Payment is not available right now");
      setBusy(false);
    }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-cream border-2 border-ink max-w-md" data-testid="buy-issue-dialog">
        <DialogTitle className="display text-4xl leading-[0.9]">Get the full issue</DialogTitle>
        <DialogDescription className="font-serif text-lg text-ink/80">
          {title}: the printable PDF, every page. {PRICE}, paid securely with Stripe.
        </DialogDescription>
        <form onSubmit={pay} className="mt-2 space-y-4">
          <label className="block">
            <span className="kicker">Your email (we send the download link here)</span>
            <input
              type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="mt-2 w-full border-2 border-ink bg-white px-4 py-3 text-base outline-none focus:border-pink"
              placeholder="you@example.com" data-testid="buy-issue-email"
            />
          </label>
          <button
            type="submit" disabled={busy}
            className="w-full inline-flex items-center justify-center gap-3 bg-ink text-cream kicker px-6 py-4 border-2 border-ink hover:bg-pink hover:text-ink transition-colors disabled:opacity-60"
            data-testid="buy-issue-pay-btn"
          >
            <Lock className="h-4 w-4" /> {busy ? "Opening secure payment…" : `Pay ${PRICE}`}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
